import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./NovaLanding.css";
import "./PrivacyPolicy.css";
import ContactModal from "./ContactModal";

export default function PrivacyPolicy() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [navShadow, setNavShadow] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  useLayoutEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const scrollingElement = document.scrollingElement;
      if (scrollingElement) {
        scrollingElement.scrollTop = 0;
      }

      const root = document.getElementById("root");
      if (root) {
        root.scrollTop = 0;
      }
    };

    scrollToTop();
    const animationFrame = window.requestAnimationFrame(scrollToTop);
    const timeout = window.setTimeout(scrollToTop, 0);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setNavShadow(window.scrollY > 6);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNav = () => {
    setMobileMenuOpen((open) => !open);
  };

  const openContactModal = (event) => {
    event?.preventDefault();
    setMobileMenuOpen(false);
    setShowContactModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  return (
    <div className="privacy-page" data-testid="privacy-policy-page">
      <header id="nav" style={{ boxShadow: navShadow ? "0 2px 24px rgba(0,0,0,.35)" : "none" }}>
        <div className="container ni">
          <Link to="/landing" className="nl" aria-label="Nova landing page" data-testid="site-nav-logo-link">
            <img
              src="https://nova.bizacuity.ai/nova-logo.png"
              alt="Nova"
              className="nl-logo"
            />
          </Link>
          <nav className="nls">
            <Link to="/landing#aud" data-testid="site-nav-audience-link">Who&apos;s It For</Link>
            <Link to="/landing#feat" data-testid="site-nav-features-link">Features</Link>
            <Link to="/landing#ind" data-testid="site-nav-industries-link">Industries</Link>
            <Link to="/landing#price" data-testid="site-nav-pricing-link">Pricing</Link>
            <button type="button" className="nav-contact" onClick={openContactModal} data-testid="site-nav-contact-button">
              Contact
            </button>
          </nav>
          <div className="na">
            <Link className="nsi" to="/login" data-testid="site-nav-sign-in-link">
              Sign In
            </Link>
            {/* <Link className="nsi" to="/landing#price" data-testid="site-nav-view-pricing-link">
              View Pricing
            </Link> */}
          </div>
          <button className="hbg" onClick={toggleNav} aria-label="Toggle navigation" aria-expanded={mobileMenuOpen} data-testid="site-nav-mobile-menu-toggle-button">
            <svg viewBox="0 0 24 24">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
        <div id="mn" style={{ display: mobileMenuOpen ? "block" : "none" }}>
          <Link to="/landing#aud" onClick={toggleNav} data-testid="site-nav-mobile-audience-link">
            Who&apos;s It For
          </Link>
          <Link to="/landing#feat" onClick={toggleNav} data-testid="site-nav-mobile-features-link">
            Features
          </Link>
          <Link to="/landing#ind" onClick={toggleNav} data-testid="site-nav-mobile-industries-link">
            Industries
          </Link>
          <Link to="/landing#price" onClick={toggleNav} data-testid="site-nav-mobile-pricing-link">
            Pricing
          </Link>
          <button type="button" className="nav-contact mobile-nav-contact" onClick={openContactModal} data-testid="site-nav-mobile-contact-button">
            Contact
          </button>
          <div className="mobile-auth-actions">
            <Link className="mobile-auth-button mobile-auth-secondary" to="/login" onClick={toggleNav} data-testid="site-nav-mobile-sign-in-link">
              Sign In
            </Link>
            {/* <Link className="mobile-auth-button mobile-auth-secondary" to="/landing#price" onClick={toggleNav} data-testid="site-nav-mobile-view-pricing-link">
              View Pricing
            </Link> */}
          </div>
        </div>
      </header>

      <main className="privacy-main">
        <section className="privacy-hero">
          <p className="privacy-eye">Legal</p>
          <h1>Privacy Policy</h1>
          <p className="privacy-subtitle">Last updated: April 2026</p>
        </section>

        <aside className="privacy-toc">
          <h3>Contents</h3>
          <ol>
            <li><a href="#s1" data-testid="privacy-policy-toc-overview-link">Privacy Policy Overview</a></li>
            <li><a href="#s2" data-testid="privacy-policy-toc-information-collected-link">Information Collected by NOVA, an Application Designed by BizAcuity</a></li>
            <li><a href="#s3" data-testid="privacy-policy-toc-cookies-link">Cookies and Related Technologies</a></li>
          </ol>
        </aside>

        <section className="privacy-section" id="s1">
          <h2>1. Privacy Policy Overview</h2>
          <p>Respect for the privacy of your personal and other information is important to us. When you use the Site, or otherwise communicate with us (e.g. via email) you will provide, and NOVA, an application designed by BizAcuity, will collect, certain information, some of which can be used to personally identify and/or locate you (“Personal Information”). This Privacy Policy describes and is intended to help you understand what that Personal Information comprises, how NOVA, an application designed by BizAcuity, uses that Personal Information, and what safeguards are in place to protect that Personal Information.</p>
          <p>By using this Site and/or otherwise communicating with us, you agree to this Privacy Policy. Please read it.</p>
          <p>We are providing this Privacy Policy to you to describe the ways we collect, use, transfer, store, secure and protect Personal Information, the ways you can exercise your rights to access and control your Personal Information, and the complaint and recourse methods available to you.</p>
        </section>

        <section className="privacy-section" id="s2">
          <h2>2. Information Collected by NOVA, an Application Designed by BizAcuity</h2>
          <p>When you use the Site, sign up for our services (or someone, such as your organization’s administrator, sign up for our services), use our website or otherwise communicate with us (e.g. via email), Personal Information will be collected by the site. The Personal Information collected is as follows, when you explicitly provide such information.</p>
          <ul>
            <li>Name</li>
            <li>Business address</li>
            <li>Email address</li>
            <li>Any customer testimonial you have given us consent to share on the Site (Please also see below “Accessing, Correcting And Deleting Your Personal Information” for information about how to update or delete your testimonial).</li>
            <li>Information you provide to the Site’s Interactive Areas. Note that any information that you post in an Interactive Area might be read, collected, and used by others who access it. You may take down any information you have added to the Interactive Areas at any time. (Please also see below “Accessing, Correcting And Deleting Your Personal Information” for information about how to delete information we hold about you).</li>
            <li>To request removal of your personal information from an Interactive Area, please contact us at <a href="mailto:hrteam@bizacuity.com">hrteam@bizacuity.com</a>.</li>
            <li>Information you provide via fillable forms or text boxes.</li>
            <li>Information about all of your interactions with the Site (“Usage Data”) and how the Site is performing (“Analytics Data”).</li>
            <li>Usage Data may include information regarding any interaction you have with the Site, such as which functionalities are used and the frequency of use (e.g., pages visited, actions taken, queries run, fields added, user accounts, account roles, and connected database types).</li>
            <li>Information gathered through cookies, pixel tags, logs, or other similar technologies.</li>
          </ul>
        </section>

        <section className="privacy-section" id="s3">
          <h2>3. Cookies and Related Technologies</h2>
          <p>Cookies are small data files that are placed on users’ devices to monitor how users interact with websites and other online services. Pixel tags, also called web beacons or single-pixel gifs, tag a graphic on a web page or in an email message that tracks pages viewed or email messages opened. Logs are continuous digital records of events and interactions that occur on a website. Cookies, pixel tags, and/or logs can be used to identify your IP address, browser type, domain name, and specific web pages through which you click and/or email messages you open.</p>
          <p>NOVA, an application designed by BizAcuity, may use cookies, pixel tags, and/or logs because they:</p>
          <ul>
            <li>Are essential for us to provide our Site to you;</li>
            <li>Help us optimize, personalize and/or otherwise improve your experience and/or the performance of the Site and our service and marketing-related communications with you.</li>
          </ul>
        </section>
      </main>

      <ContactModal open={showContactModal} onClose={closeContactModal} />

      <footer className="privacy-footer">
        <p>
          <Link to="/landing" data-testid="privacy-policy-footer-home-link">Home</Link>
          <Link to="/privacypolicy" data-testid="privacy-policy-footer-privacy-policy-link">Privacy Policy</Link>
          <button type="button" className="footer-contact" onClick={openContactModal} data-testid="privacy-policy-footer-contact-button">
            Contact Us
          </button>
        </p>
        <p className="privacy-footer-copy">© {new Date().getFullYear()} Nova by BizAcuity. All rights reserved.</p>
      </footer>
    </div>
  );
}
